<script setup>
import { formatCounterReference } from './counterLabels.js'

defineProps({
  counters: { type: Array, default: () => [] },
  emptyMessage: { type: String, default: 'Дані відсутні' },
})

const number = (value) => value == null ? '—' : new Intl.NumberFormat('uk-UA', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
}).format(value)
const directionTitle = {
  counter_greater: 'Лічильник більший за продажі БД',
  database_greater: 'Продажі БД більші за лічильник',
  equal: 'Розбіжності немає',
  unknown: 'Немає підтверджених даних',
}
</script>

<template>
  <section class="indicator-section counters-section" aria-labelledby="historical-counters-heading">
    <div class="counter-heading"><h2 id="historical-counters-heading"><span>04</span> Змінні лічильники</h2></div>
    <div class="dashboard-panel table-wrap counters-wrap">
      <table v-if="counters.length" class="counter-table"><thead><tr><th rowspan="2">ПРК</th><th rowspan="2">Пістолет</th><th rowspan="2">Резервуар</th><th colspan="2">На початок</th><th colspan="2">На кінець</th><th colspan="2">Продаж всього</th><th colspan="2">Різниця</th></tr><tr><th>л</th><th>UAH</th><th>л</th><th>UAH</th><th>л</th><th>UAH</th><th>л</th><th>UAH</th></tr></thead>
        <tbody><tr v-for="counter in counters" :key="`${counter.pumpNumber}-${counter.nozzleNumber}-${counter.tankNumber}`"><th>№{{ counter.pumpNumber }}</th><td>{{ formatCounterReference(counter.nozzleNumber, counter.productName) }}</td><td>{{ formatCounterReference(counter.tankNumber, counter.productId) }}</td><td>{{ number(counter.startLiters) }}</td><td>{{ number(counter.startAmount) }}</td><td>{{ number(counter.endLiters) }}</td><td>{{ number(counter.endAmount) }}</td><td>{{ number(counter.totalSalesLiters) }}</td><td>{{ number(counter.totalSalesAmount) }}</td><td :title="directionTitle[counter.differenceLitersDirection]">{{ number(counter.differenceLiters) }}</td><td>{{ number(counter.differenceAmount) }}</td></tr></tbody>
      </table>
      <p v-if="!counters.length" class="section-unavailable">{{ emptyMessage }}</p>
    </div>
    <p v-if="counters.length" class="counter-note">Об'єми — у літрах (л), суми — у гривнях (UAH). «На кінець» відповідає закриттю вибраної зміни.</p>
  </section>
</template>
